<template>
    <div class="footer">
      <span>CopyRight©{{name}} All Rights Reserved</span>
      <!-- <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">京ICP备19055464号-1</a>   -->
       <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">京ICP备{{icp}}</a>  
    </div>
</template>

<script>
import auth from "@/utils/auth";
import utils from "@/utils/utils";
  export default {
    name: 'Footer',
    data: function() {
    return {
     name:"",
     icp:""
    };
    },

  created() {
     this.name = utils.getName();
    this.icp = utils.getICP(); 
     }
  }
</script>

<style scoped>

.footer {position: absolute;bottom: 0;right: 0;left: 256px;background-color: #fff;
  padding: 0px 0 20px 0;
  text-align: center;
  font-size: 12px;
  color: #777;
}
.footer span {
  display: inline-block;padding: 0 10px;
}
.footer a {
  display: inline-block;padding: 0 5px;color: #777;
}
</style>




// WEBPACK FOOTER //
// src/components/common/Footer.vue